export const STAKES = [0, 10, 50, 100, 500];
export function isValidStake(value) {
    return typeof value === 'number' && STAKES.includes(value);
}
export const TABLE_SIZES = [2, 3, 4, 5, 6];
export function isValidTableSize(value) {
    return typeof value === 'number' && TABLE_SIZES.includes(value);
}
export const PLATFORM_COMMISSION_BPS = 1000;
export const COMMISSION_DENOMINATOR_BPS = 10_000;
export function commissionStars(potStars) {
    return Math.floor((potStars * PLATFORM_COMMISSION_BPS) / COMMISSION_DENOMINATOR_BPS);
}
export function netPotStars(potStars) {
    return potStars - commissionStars(potStars);
}
/**
 * Per-winner share for an N-player match.
 * Loser gets nothing; the (N-1) non-losers split the post-commission pot evenly.
 * Rounding remainder is treated as additional commission.
 *
 * @returns share size in Stars; 0 if there are no eligible winners (e.g., draw handled elsewhere)
 */
export function perWinnerShareStars(potStars, playerCount) {
    if (playerCount < 2)
        return 0;
    const winners = playerCount - 1;
    return Math.floor(netPotStars(potStars) / winners);
}
/** @deprecated use netPotStars (renamed for clarity in N-player payouts) */
export const payoutStars = netPotStars;
//# sourceMappingURL=stakes.js.map